<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <div class="h-100 d-flex justify-content-center align-items-center" v-if="isLoading">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
            <div v-else>
                <price-deviation-prod-info
                    :submission="submission"
                    :styleAndSkus="styleAndSkus"
                    :imgSource="imgSource"
                    :custInfo="custInfo"
                ></price-deviation-prod-info>
                <br>
                <div>
                    <form @submit.prevent="saveSkuSelection" method="POST">
                        <h2>SKU Level Information</h2>
                        <em id="em-stylings">
                            Select each SKU that is going to be affected by this new pricing.
                        </em>
                        <br />
                        <em id="em-stylings" style="color:#cd1b00;">
                            New LIST pricing will be provided 60 days in advance of a new semi-annual price list and will be used <br />
                            in variance calculations when submitting deviation requests in the window leading up to the semi-annual price list going live.
                        </em>
                        <div style="overflow-x: auto;">
                            <table class="table-striped" id="skuTBL" cellspacing="0" cellpadding="0">
                                <tr class="TBLhead">
                                    <th>IREF</th>
                                    <th>SKU</th>
                                    <th>COLOR</th>
                                    <th>SIZE</th>
                                    <th>STATUS</th>
                                    <th>PRICE LIST</th>
                                    <th>CURR/*NEW<br>LIST PRICE</th>
                                    <th>% CHANGE</th>
                                    <th>CURR/NEW<br>CUST PRICE</th>
                                    <th>CURR/NEW<br>VAR% LIST</th>
                                    <th>CUST PRICE DESC</th>
                                    <th>6M/12M SALES</th>
                                </tr>
                                <tr v-for="sku in styleAndSkus['children_skus']">
                                    <td>
                                        <input v-if="activityId != '5'" 
                                               type="checkbox" 
                                               class="irefCHK" 
                                               :checked="isSkuSelected(sku)"
                                               @change="toggleSelected(sku)" 
                                               style="margin-left:.5rem;"/>
                                        {{ sku['prod_id'] }}
                                    </td>
                                    <td>{{ sku['sku'] }}</td>
                                    <td>{{ sku['color'] }}</td>
                                    <td>{{ sku['size'] }}</td>
                                    <td>{{ sku['status'] }}</td>
                                    <td>{{ sku['price_list_output'] }}</td>
                                    <td>
                                        ${{ sku['curr_list_price'] }} ({{ sku['uom']['uom'] }})<br>
                                        ${{ sku['new_list_price'] }} ({{ sku['uom']['uom'] }})
                                    </td>
                                    <td>{{ sku['list_perc_change'] }}%</td>
                                    <td>
                                        ${{ sku['curr_cust_price'] }} ({{ sku['uom']['uom'] }})<br>
                                        ${{ sku['new_cust_price'] }} ({{ sku['uom']['uom'] }})
                                    </td>
                                    <td>
                                        {{ sku['curr_list_var'] }}%<br>
                                        {{ sku['new_list_var'] }}%
                                    </td>
                                    <td>{{ sku['price_desc'] }}</td>
                                    <td>
                                        ${{ sku['sales'][0]['sales_6'] }}<br>
                                        ${{ sku['sales'][0]['sales_12'] }}
                                    </td>
                                </tr>
                                <tr v-if="activityId != '5'" id="checkAllRow">
                                    <td colspan="12">
                                        <input type="checkbox" id="checkAll" v-on:click="checkAll()" style="margin-left:.5rem;"> SELECT ALL
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <br />
                        <button v-if="activityId != '5'" class="btn-round-red" type="submit">NEXT STEP ></button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activity: "",
            activityId: "",
            childrenSkus: [],
            custInfo: {},
            imgSource: "",
            isLoading: true,
            prodImg: {},
            selectedSkus: [],
            skus: [],
            styleAndSkus: {},
            submission: {},
        }
    },
    props: ['ppId'],
    async created() {
        await axios.get(`/api/getStyleAndChildrenSkus/${this.ppId}`).then(response => {
            this.styleAndSkus = response.data;
            this.childrenSkus = this.styleAndSkus['children_skus'];
            this.skus = this.styleAndSkus['children_skus'];
            this.imgSource = this.styleAndSkus['img_source'];
        });
        await axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.activityId = this.submission.activity.id;
            this.activity = this.submission.activity.activity;

            // this.selectedSkus = this.submission.price_sku;
            this.selectedSkus = this.childrenSkus.filter(childSku => {
                return this.submission.price_sku.some(sku => sku['prod_id'] === childSku['prod_id']);
            });

            axios.get(`/api/customerInfo/${this.submission.cust_id}`).then(response => {
                this.custInfo = response.data;
            });

            this.isLoading = false;
        });
    },
    watch: {
        selectedSkus() {
            if(this.selectedSkus.length == $('.irefCHK').length) {
                $("#checkAll").prop('checked', true);
            } else {
                $("#checkAll").prop('checked', false);
            }
        }
    },
    computed: {
        selectedSkuProdIds() {
            return this.selectedSkus.map(sku => sku['prod_id']);
        }
    },
    methods: {
        isSkuSelected(sku) {
            return this.selectedSkuProdIds.includes(sku['prod_id']);
        },
        toggleSelected(sku) {
            if(this.isSkuSelected(sku)) {
                this.selectedSkus = this.selectedSkus.filter(item => item !== sku);
            } else {
                this.selectedSkus.push(sku);
            }
        },
        saveSkuSelection() {
            if(this.selectedSkus.length == 0) {
                alert("Please select at least one SKU.");
                return;
            } else {
                let data = {
                    id: this.ppId,
                    selectedSkus: this.selectedSkus
                }

                axios.post(`/api/saveSkuSelections`, data).then(response => {
                    this.$router.push({
                        name: "PriceWorkflowPricing",
                        params: { ppId: this.ppId }
                    });
                });
            }
        },
        checkAll() {
            if($("#checkAll").prop('checked') == true) {
                this.selectedSkus = [];
                
                for(let sku of this.skus) {
                    this.selectedSkus.push(sku);
                }
            } else {
                this.selectedSkus = [];
            }
        }
    },
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #em-stylings {
        font-size:.9rem; 
        font-weight:normal; 
        line-height:1.0
    }

    h2 {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    #skuTBL {
        width: 100%;
        margin: 0;
        text-align: left;
        font-size: 0.9rem;
    }

    #checkAllRow {
        font-size: 0.8rem;
        font-weight: normal;
        color: #999;
        border-top: solid 1px #333;
    }

    th, td {
        padding:.5rem;
    }

    .TBLhead th {
        font-weight: bold;
        border-bottom: solid 1px #333;
        margin-bottom: 0;
        vertical-align: bottom;
        text-align: left;
    }

    tr:nth-child(even) {
        background-color: #f7f7f7;
    }
</style>
